import { WORLD_WIDE_COUNTRY_ID } from "app/pages/activation/components/RankWidget/config";
import type { RankTrackerCountry } from "app/pages/activation/types/api";

export const getIsAvailableCountrySelected = (availableCountries: RankTrackerCountry[], country: number): boolean =>
    country !== WORLD_WIDE_COUNTRY_ID &&
    availableCountries.some((availableCountry) => availableCountry.code === country);
